import React, { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "../components/_app/Layout";
import LoginPage from "../pages/auth/LoginPage";
import OtpVerification from "../pages/auth/OtpVerification";
import ResetPasswordPage from "../pages/auth/ResetPasswordPage";
import ConfigurationMain from "../pages/configuration/ConfigurationMain";
import TaskManageMain from "../pages/map1/TaskManageMain";
import NotificationSection from "../pages/profile/NotificationSection";
import ProfileSection from "../pages/profile/ProfileSection";
import Settings from "../pages/profile/Settings";
import ReportList from "../pages/reports/ReportList";
import CreateTask from "../pages/task/CreateTask";
import ImportCsv from "../pages/task/ImportCsv";
import TaskDetailPage from "../pages/task/TaskDetailPage";
import AddUser from "../pages/users/AddUser";
import UserList from "../pages/users/UserList";
import WorkflowMain from "../pages/workflow/WorkflowMain";

import ExportData from "../pages/worklog/ExportData";
import ProtectedRoute from "../ProtecedRoutes/ProtectedRoute";
import GetDetails from "../pages/workflow/Updateworkflow/GetDetails";
import PdfGenerator from "../pages/PDF_Generator/PdfGenerator";
import PdfExportHistory from "../pages/PDF_Generator/PdfExportHistory";
import Dashboard from "../pages/Dashboard/Dashboard";
import { Security } from "../components/Security/Security";
import { ProtectionForm } from "../components/Security/ProtectionForm";
import { ProtectionJobs } from "../components/Security/ProtectionJobs";
import { InstallmentPlan } from "../components/InstallmentPlan/InstallmentPlan";
import TaskListView from "../components/task/TaskListView";
import OrgnizationList from "../components/Orgnization/OrgnizationList";
import TaskHistory from "../pages/TaskHistory/TaskHistory";
import ActivityDashboard from "../components/dashboard/actvity/ActivityDashboard";
import { StockManagement } from "../components/StockManagement/StockManagement";
import CreateStorePage from "../components/StockManagement/CreateStorePage";
import InventoryManagement from "../components/InventoryManagement/InventoryManagement";
import { UploadExcelReport } from "../components/StockManagement/UploadExcelReport";
import UpdateTask from "../components/task/UpdateCompleteTask/UpdateTask";
import CustomerSupport from "../pages/support/CustomerSupport";
import RoleManagement from "../pages/role/RoleManagement";
import FrontEndProcessing from "../pages/FrontEndProcessing";
import DesktopTabletOnly from "../pages/workflow/DesktopTabletOnly";
import DynamicWorkFlow from "./../pages/workflow/DynamicWorkFlow"; // update by harshit
import MapView from "../components/Map/MapView";
import AppUpdateConfig from "../pages/appConfig/AppUpdateConfig";
import InventoryConfiguration from "../pages/inventory/InventoryConfiguration";
import AddInventory from "../pages/inventory/AddInventory";
import { getDefaultRouteFromPermissions, isSuperAdmin } from "../utils/permissions";

const Router = () => {
  const [user] = useState(null);

  const loggedIn = window.localStorage.getItem("isLoggedIn");

  if (!window.localStorage.getItem("accessToken")) {
    return <LoginPage />;
  }
  return (
    <Routes>
      <Route path="/front1234end" element={<FrontEndProcessing />} />
      <Route
        path="/"
        element={
          loggedIn ? (
            <Navigate
              to={getDefaultRouteFromPermissions() || "/maptask"}
              replace
            />
          ) : (
            <LoginPage />
          )
        }
      />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/otp-verify" element={<OtpVerification />} />
      <Route
        path="/dashboard"
        element={
          <Layout>
            <Dashboard />
          </Layout>
        }
      />
      <Route
        path="/customer-support"
        element={
          <Layout>
            <ProtectedRoute screenCode="CUSTOMER_SUPPORT" requiredPermission="canView">
              <CustomerSupport />
            </ProtectedRoute>
          </Layout>
        }
      />
   
     
      <Route
        path="/pdf-generator"
        element={
          <ProtectedRoute screenCode="PDF_REPORT" requiredPermission="canView">
            <Layout>
              <PdfGenerator />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/pdf-export-history"
        element={
          <ProtectedRoute screenCode="PDF_REPORT" requiredPermission="canView">
            <Layout>
              <PdfExportHistory />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/task-detail/:taskId"
        element={
          <Layout>
            <TaskDetailPage />
          </Layout>
        }
      />
      <Route
        path="/*"
        element={
          <Routes>
            <Route
              path="all-users"
              element={
                <Layout>
                  <UserList />
                </Layout>
              }
            />
            <Route
              path="role-management"
              element={
                <Layout>
                  <RoleManagement />
                </Layout>
              }
            />
            <Route
              path="/add-user"
              element={
                <ProtectedRoute screenCode="USER_MANAGEMENT" requiredPermission="canView">
                  <Layout>
                    <AddUser />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-user/:userId"
              element={
                <ProtectedRoute screenCode="USER_MANAGEMENT" requiredPermission="canView">
                  <Layout>
                    <AddUser />
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        }
      />
      <Route
        path="/user-profile"
        element={
          <Layout>
            <ProfileSection />
          </Layout>
        }
      />
      <Route
        path="/settings"
        element={
          <Layout>
            <Settings />
          </Layout>
        }
      />
      <Route
        path="/notification"
        element={
          <Layout>
            <NotificationSection />
          </Layout>
        }
      />

      <Route
        path="/task/*"
        element={
          <Routes>
            <Route
              path="import-csv"
              element={
                <Layout>
                  <ImportCsv />
                </Layout>
              }
            />
            <Route
              path="create-task"
              element={
                <Layout>
                  <CreateTask />
                </Layout>
              }
            />
          </Routes>
        }
      />
      <Route
        path="/configuration"
        element={
          <ProtectedRoute
            screenCode={["CONFIGURATION","ASSIGNMENT_RULES", "SPECIAL_ASSIGNMENT_RULES"]}
            requiredPermission="canView"
          >
            <Layout>
              <ConfigurationMain />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/workflow"
        element={
          <Layout>
            <WorkflowMain />
          </Layout>
        }
      />
      {/*  update by harshit -- start */}
      <Route
        path="/workflow-form"
        element={
          <ProtectedRoute screenCode="WORKFLOW" requiredPermission="canView">
            <Layout>
              <DesktopTabletOnly>
                <DynamicWorkFlow />
              </DesktopTabletOnly>
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* update by harshit -- end */}
      <Route
        path="/worklog"
        element={
          <ProtectedRoute screenCode="WORKLOG" requiredPermission="canView">
            <Navigate to="/pdf-generator" replace />
          </ProtectedRoute>
        }
      />
      <Route
        path="/task-manage"
        element={
          // <ProtectedRoute privilegesRequired={["canTaskManage"]}>
          <Layout>
            <TaskManageMain />
          </Layout>
          // </ProtectedRoute>
        }
      />
      <Route
        path="/reports"
        element={
          <Layout>
            <ReportList />
          </Layout>
        }
      />
      <Route
        path="/task-detail"
        element={
          <Layout>
            <TaskDetailPage />
          </Layout>
        }
      />
      <Route
        path="/export-report-and-data"
        element={
          <Layout>
            <ExportData />
          </Layout>
        }
      />
      <Route
        path="/get-workflow-details/:workflowId"
        element={
          <Layout>
            <GetDetails />
          </Layout>
        }
      />
      <Route
        path="/update-complete-task/:taskId"
        element={
          <Layout>
            <UpdateTask />
          </Layout>
        }
      />
      <Route
        path="/security"
        element={
          // <ProtectedRoute privilegesRequired={["canAddEditProtectedAccount"]}>
          <Layout>
            <Security />
          </Layout>
          // </ProtectedRoute>
        }
      />
      <Route
        path="/security/protection-jobs"
        element={
          <Layout>
            <ProtectionJobs />
          </Layout>
        }
      />
      <Route
        path="/special-form"
        element={
          <Layout>
            <ProtectionForm />
          </Layout>
        }
      />
      <Route
        path="/installment-plan"
        element={
          <Layout>
            <InstallmentPlan />
          </Layout>
        }
      />
      <Route
        path="/maptask"
        element={
          // <ProtectedRoute privilegesRequired={["canTaskManage"]}>
          <Layout>
            <MapView />
          </Layout>
          // </ProtectedRoute>
        }
      />

      <Route
        path="/listview"
        element={
          <Layout>
            <TaskListView />
          </Layout>
        }
      />

      <Route
        path="/organization"
        element={
          <Layout>
            <OrgnizationList />
          </Layout>
        }
      />
     
      <Route
        path="/activty-dashboard"
        element={
          <Layout>
            <ActivityDashboard />
          </Layout>
        }
      />
      <Route
        path="/stock-managment"
        element={
          // <ProtectedRoute privilegesRequired={["canAddEditInventory"]}>
          <Layout>
            <StockManagement />
          </Layout>
          // </ProtectedRoute>
        }
      />
      <Route
        path="/stock-managment/stores"
        element={<Navigate to="/inventory-management/stores" replace />}
      />
      {/* Store management is super-admin only; other roles go back to the inventory list. */}
      <Route
        path="/inventory-management/stores"
        element={
          isSuperAdmin() ? (
            <Layout>
              <CreateStorePage />
            </Layout>
          ) : (
            <Navigate to="/inventory-management" replace />
          )
        }
      />
      <Route
        path="/inventory-management"
        element={
          <Layout>
            <InventoryManagement />
          </Layout>
        }
      />
      <Route path="/inventory-management/configuration" element={<Layout><InventoryConfiguration /></Layout>} />
      <Route
        path="/inventory-management/add"
        element={
          <Layout>
            <AddInventory />
          </Layout>
        }
      />
      {/* Sheet upload and its history now live on Add Inventory's Excel Upload tab. */}
      <Route
        path="/inventory-management/import"
        element={<Navigate to="/inventory-management/add?tab=import&view=history" replace />}
      />
      <Route
        path="/upload-stock-data"
        element={
          <Layout>
            <UploadExcelReport />
          </Layout>
        }
      />
      <Route
        path="/app-update-config"
        element={
          isSuperAdmin() ? (
            <Layout>
              <AppUpdateConfig />
            </Layout>
          ) : (
            <Navigate
              to={getDefaultRouteFromPermissions() || "/maptask"}
              replace
            />
          )
        }
      />
    </Routes>
  );
};

export default Router;
